<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
    	<el-breadcrumb-item :to="{ path: '/' }">物业管理</el-breadcrumb-item>
    	<el-breadcrumb-item>交易记录</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>
    	<el-form-item label="搜索：">
    		<el-input size="small" @keyup.enter.native="search" v-model="formInline.roomName" placeholder="输入房间名称"></el-input>
    	</el-form-item>
      <el-form-item >
      	<el-input size="small" @keyup.enter.native="search" v-model="formInline.username" placeholder="输入用户名称"></el-input>
      </el-form-item>
      <el-form-item>
      	<el-select size="small" v-model="formInline.isRecharge" placeholder="选择类型" style="width: 150px;" @keyup.enter.native="search">
      		<el-option v-for="type in payType" :label="type.lable" :value="type.value" :key="type.value"></el-option>
      	</el-select>
      </el-form-item>
      <el-form-item>
      	<div style="position: relative;top: 1px;">
      	<el-date-picker
      	  size="small"
      	  v-model="dataStr"

      	  type="daterange"
      	  range-separator="至"
      	  start-placeholder="开始日期"
      	  @change="getDate"
      	  end-placeholder="结束日期">
      	</el-date-picker>
      	</div>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
          <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small">
             <el-option
               v-for="item in deptList"
               :key="item.id"
               :label="item.departmentName"
               :value="item.id">
             </el-option>
           </el-select>
       </el-form-item>

    	<el-form-item>
    		<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    	</el-form-item>
    </el-form>

    <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
     style="width: 100%;"  stripe :max-height="tableHeight">
    	<el-table-column align="center" type="index" width="60">
    	</el-table-column>
    	<el-table-column prop="roomName" label="房间"   show-overflow-tooltip>
    	</el-table-column>
    	<el-table-column prop="username" label="用户账号"  show-overflow-tooltip>
    	</el-table-column>
    	<el-table-column prop="money" label="交易金额"  show-overflow-tooltip>
    	</el-table-column>
      <el-table-column  label="充值类型" show-overflow-tooltip >
      	<template slot-scope="scope">
      		<el-tag size="mini"  v-if="scope.row.roomType == 63">水费</el-tag>
      		<el-tag size="mini" type="success" v-if="scope.row.roomType == 64">物业费</el-tag>

      	</template>
      </el-table-column>
    	<el-table-column  sortable prop="createDate" label="创建时间"show-overflow-tooltip>
    	</el-table-column>
    	<!-- <el-table-column prop="orderNo" label="订单号" width="200" show-overflow-tooltip>
    	</el-table-column> -->



    	<el-table-column prop="mark" label="备注"  show-overflow-tooltip>
    	</el-table-column>

    	<el-table-column  label="支付方式" width="120" show-overflow-tooltip  v-if="formInline.isRecharge != 3">
    		<template slot-scope="scope">
    			<span v-if="scope.row.payType == 7">多还少补</span>
    			<span v-if="scope.row.payType == 6">其他</span>
    			<span v-if="scope.row.payType == 5">微信</span>
    			<span v-if="scope.row.payType == 4">支付宝</span>
    			<span v-if="scope.row.payType == 3">POS</span>
    			<span v-if="scope.row.payType == 2">转账</span>
    			<span v-if="scope.row.payType == 1">现金</span>
    		</template>
    	</el-table-column>
    	<el-table-column prop="transType" label="交易类型" width="120" show-overflow-tooltip >
    		<template slot-scope="scope">
    			<!-- {{scope.row.isRecharge == 3}} -->
    			<span v-if="scope.row.isRecharge == 1">充值</span>
    			<span v-if="scope.row.isRecharge == 2">退款</span>
    			<span v-if="scope.row.isRecharge == 3">扣费</span>
    		</template>
    	</el-table-column>





    </el-table>
    <!-- 分页组件 -->
    <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
  import { findRoomAccountList  } from '../../api/payMG.js'
  import { getDepartmentTerminalInfoLis } from '../../api/energyMG'
  import {timestampToTime} from '@/utils/util'
  import Pagination from '../../components/Pagination'
  export default{
    data(){
      return {
        tableHeight:0,
        dataList:[],
        dataStr:[],
        payType:[
        	{lable:'充值',value:1},
          {lable:'退款',value:2},
        	{lable:'扣费',value:3},

        ],
        formInline:{
          roomName:"",
          userName:"",
          isRecharge:"",
          startTime:"",
          endTime:"",
          depId:"",
        },
        user:{},
        showPage:true,
        loading:false,
        deptList:[],
        pageparm: {
        	currentPage: 1,
        	pageSize: 10,
        	total: 10
        },
      }
    },
    created(){
       this.user = JSON.parse(sessionStorage.getItem('userdata'))
       this.getData()
       this.getJzData()

    },
    mounted(){
      this.$nextTick(() => {

        this.tableHeight = window.innerHeight - 300
      })
    },
    components: {
    	Pagination
    },
    methods:{
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
              res.data.terIds.forEach( item => {
              	arr.push({ id: item})
              })
              resolve(this.deptList[0])

      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      getDate(val){
      	// this.exportParam.startTime  = timestampToTime(this.dataStr[0]).substring(0, 10)
      	// this.exportParam.endTime  = timestampToTime(this.dataStr[1]).substring(0, 10)
      	this.formInline.startTime  = timestampToTime(this.dataStr[0]).substring(0, 10)
      	this.formInline.endTime  = timestampToTime(this.dataStr[1]).substring(0, 10)

      	this.search()

      },
      search(){

          this.pageparm.currentPage = 1
          this.formInline.currentPage = 1
          this.showPage  =  false;
          this.getData()
          this.$nextTick(() => {
          	this.showPage = true
          })
      },
      callFather(parm){
        this.pageparm.currentPage = parm.currentPage
        this.pageparm.pageSize = parm.pageSize
        this.getData()
      },
      getData(){
        this.loading = true
        let param  = {
          ...this.formInline,
          ...this.pageparm
        }
        findRoomAccountList(param).then(res => {
          this.loading = false
          if(res.status == 1) {
            this.dataList = res.data.data
            this.pageparm.total = res.data.totalCount
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/Porder.vue